(function () {
  if (window.__ksBroadcastCartSync) return;
  window.__ksBroadcastCartSync = true;

  const LOG = '[KS Broadcast Cart Sync]';
  const root = window.Shopify?.routes?.root || '/';
  const ERROR_EXPANDED_CLASS = 'is-expanded';
  const DEFAULT_LIMIT_HEADING = "Sorry, looks like we don't have enough of this product.";

  let changeInFlight = false;
  let lastUserCloseAt = 0;
  let lastChangeStartedAt = 0;
  let changeSeq = 0;

  function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  function eventElement(event) {
    const target = event.target;
    if (target instanceof Element) return target;
    return target && target.parentElement ? target.parentElement : null;
  }

  function getDrawer() {
    return (
      document.querySelector('cart-drawer#cart-drawer') ||
      document.querySelector('#cart-drawer') ||
      document.querySelector('.drawer--cart')
    );
  }

  function getDrawerSectionId() {
    const drawer = getDrawer() || document.querySelector('[data-section-type="cart-drawer"]');
    const section = drawer?.closest('[id^="shopify-section-"]');

    if (section) {
      return section.id.replace('shopify-section-', '');
    }

    const fallback = document.querySelector('[data-section-type="cart-drawer"]');
    return fallback?.dataset?.sectionId || null;
  }

  function forceDrawerOpen() {
    const drawer = getDrawer();
    if (!drawer) return;

    drawer.classList.add('is-open', 'is-updated');
    drawer.classList.remove('is-closing', 'is-closed');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.removeAttribute('hidden');

    document.documentElement.classList.add('js-drawer-open', 'cart-drawer-open');
    document.body.classList.add('js-drawer-open', 'cart-drawer-open');
  }

  function revealCartItems() {
    const drawer = getDrawer();
    if (!drawer) return;

    drawer.querySelectorAll(
      'cart-items[data-items-holder] .is-animated, cart-items[data-items-holder] [data-animation]'
    ).forEach(el => {
      el.classList.remove('is-animated');
      el.style.opacity = '1';
      el.style.visibility = 'visible';
      el.style.transform = 'none';
      el.style.animation = 'none';
      el.style.transition = 'none';
    });

    drawer.querySelectorAll('cart-items[data-items-holder] .cart__item').forEach(el => {
      el.style.opacity = '1';
      el.style.visibility = 'visible';
      el.style.transform = 'none';
      el.style.display = '';
      el.style.pointerEvents = '';
    });
  }

  function clearRowLoading(row) {
    if (!row) return;
    row.style.opacity = '';
    row.style.pointerEvents = '';
  }

  function setRowLoading(row) {
    if (!row) return;
    row.style.opacity = '0.45';
    row.style.pointerEvents = 'none';
  }

  function getErrorHolder() {
    const drawer = getDrawer();
    return (
      drawer?.querySelector('[data-cart-errors]') ||
      document.querySelector('[data-cart-errors]')
    );
  }

  function showInventoryLimitError(itemTitle) {
    const holder = getErrorHolder();
    if (!holder) return;

    const heading = holder.querySelector('.cart__errors__heading');
    const messageEl = holder.querySelector('[data-error-message]');

    if (heading) {
      if (!heading.dataset.ksDefaultHeading) {
        heading.dataset.ksDefaultHeading = heading.textContent.trim() || DEFAULT_LIMIT_HEADING;
      }
      heading.textContent = heading.dataset.ksDefaultHeading;
    }

    if (messageEl) {
      messageEl.textContent = itemTitle || '';
    }

    holder.classList.add(ERROR_EXPANDED_CLASS);
  }

  function showGenericCartError(message) {
    const holder = getErrorHolder();
    if (!holder) return;

    const heading = holder.querySelector('.cart__errors__heading');
    const messageEl = holder.querySelector('[data-error-message]');

    if (heading) {
      if (!heading.dataset.ksDefaultHeading) {
        heading.dataset.ksDefaultHeading = heading.textContent.trim() || DEFAULT_LIMIT_HEADING;
      }
      heading.textContent = 'Couldn’t update your cart';
    }

    if (messageEl) {
      messageEl.textContent = message || 'Please try again.';
    }

    holder.classList.add(ERROR_EXPANDED_CLASS);
  }

  function hideCartError() {
    const holder = getErrorHolder();
    if (!holder) return;

    const heading = holder.querySelector('.cart__errors__heading');
    if (heading?.dataset?.ksDefaultHeading) {
      heading.textContent = heading.dataset.ksDefaultHeading;
    }

    holder.classList.remove(ERROR_EXPANDED_CLASS);
  }

  function resetRowQuantity(row, quantity) {
    if (!row) return;

    const input = row.querySelector('.cart__quantity-field');
    if (input) {
      input.value = String(quantity);
      input.defaultValue = String(quantity);
    }

    const toggleText = row.querySelector('[data-popout-toggle-text]');
    if (toggleText) {
      toggleText.textContent = String(quantity);
    }
  }

  function getMaxQuantity(row) {
    const input = row?.querySelector('.cart__quantity-field');
    const fromData = Number(input?.dataset?.maxInventory || '');
    const fromMax = Number(input?.getAttribute('max') || '');

    if (Number.isFinite(fromData) && fromData > 0) return fromData;
    if (Number.isFinite(fromMax) && fromMax > 0) return fromMax;
    return null;
  }

  function isInventoryLimitMessage(message) {
    const text = String(message || '').toLowerCase();
    return (
      text.includes('not enough') ||
      text.includes('do not have enough') ||
      text.includes("don't have enough") ||
      text.includes('inventory') ||
      text.includes('cannot find variant') ||
      text.includes('exceeds')
    );
  }

  function updateInnerHTML(newDoc, selector) {
    const current = document.querySelector(selector);
    const fresh = newDoc.querySelector(selector);

    if (!current || !fresh) return false;

    current.innerHTML = fresh.innerHTML;
    console.log(LOG, 'Updated:', selector);
    return true;
  }

  /**
   * The campaign card's visible state is driven by the slot element's own
   * data-ks-state attribute (CSS picks the state div), so innerHTML swaps
   * leave the card stuck in the previous state. Replace the whole node so
   * the server-computed state, data attributes, and bar widths all apply,
   * then sync the checkout gating and notify listeners (Rebuy headline).
   */
  function replaceProgressSlot(newDoc) {
    const current = document.querySelector('#ks-free-shipping-progress-slot');
    const fresh = newDoc.querySelector('#ks-free-shipping-progress-slot');

    if (!current || !fresh) return false;

    current.replaceWith(fresh);

    const state = fresh.dataset.ksState;
    const belowMinimum = state === 'minimum';

    const drawer = getDrawer();
    if (drawer) {
      drawer.classList.toggle('ks-below-minimum', belowMinimum);
    }

    document.querySelectorAll('[data-ks-minimum-note]').forEach(note => {
      note.hidden = !belowMinimum;
    });

    document.dispatchEvent(
      new CustomEvent('ks:cart-state:updated', {
        detail: {
          state: state,
          eligibleTotal: Number(fresh.dataset.ksEligibleTotal || 0),
          threshold: Number(fresh.dataset.ksThreshold || 0),
          minimumThreshold: Number(fresh.dataset.ksMinimumThreshold || 0)
        }
      })
    );

    console.log(LOG, 'Progress slot replaced, state:', state);
    return true;
  }

  function updateCartCount(newDoc) {
    const freshCount = newDoc.querySelector('[data-cart-count]');
    if (!freshCount) return false;

    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = freshCount.textContent;
      el.setAttribute(
        'data-cart-count',
        freshCount.getAttribute('data-cart-count') || freshCount.textContent.trim()
      );
    });

    return true;
  }

  /**
   * refreshDrawer swaps innerHTML only, so the theme's cart-items component
   * never learns the new item count: the drawer keeps no `is-empty` class and
   * the Rebuy widget / campaign foot stay visible after the last item is
   * removed. Mirror what theme.js toggleClassesOnContainers() does.
   */
  function syncEmptyState(newDoc) {
    const drawer = getDrawer();
    if (!drawer) return;

    const freshHolder = newDoc.querySelector('cart-items[data-items-holder]');
    const count = freshHolder ? freshHolder.querySelectorAll('[data-item]').length : 0;
    const isEmpty = count === 0;

    drawer.classList.toggle('is-empty', isEmpty);

    const itemsEl = drawer.querySelector('cart-items[data-items-holder]');
    if (itemsEl && 'totalItems' in itemsEl) {
      itemsEl.totalItems = count;
    }

    if (isEmpty) {
      drawer.querySelectorAll('[data-cart-empty] [data-animation]').forEach(el => {
        el.classList.remove('is-hiding');
        el.classList.add('is-animated');
      });
    }
  }

  /**
   * forceDrawerOpen() adds `is-updated`, and theme.js only clears it while the
   * drawer still has `is-open`, so it survived closing. With `is-updated` the
   * close animation never fires animationend and every animated block
   * (including the header with the close button) stays `is-hiding`, i.e.
   * invisible, the next time the drawer opens.
   */
  function watchDrawerOpenState() {
    const drawer = getDrawer();
    if (!drawer || drawer.__ksOpenWatch) return;
    drawer.__ksOpenWatch = true;

    let wasOpen = drawer.classList.contains('is-open');
    new MutationObserver(() => {
      const isOpen = drawer.classList.contains('is-open');
      if (isOpen === wasOpen) return;
      wasOpen = isOpen;

      if (!isOpen) {
        drawer.classList.remove('is-updated');
        return;
      }

      drawer.querySelectorAll('[data-animation].is-hiding').forEach(el => {
        el.classList.remove('is-hiding');
      });
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  /**
   * Quantity dropdown in the drawer: theme.js decides up/down from the window
   * midpoint, but the list is clipped by .drawer__body (scroll container)
   * whose bottom sits above the tall campaign foot. Re-place it against the
   * body's visible box instead.
   */
  function fitDrawerPopout(toggle) {
    const drawer = getDrawer();
    const body = drawer?.querySelector('[data-cart-drawer-body]');
    const popout = toggle.closest('.select-popout') || toggle.parentElement;
    const list = popout?.querySelector('.select-popout__list');
    if (!body || !list || !list.classList.contains('popout-list--visible')) return;

    const bodyRect = body.getBoundingClientRect();
    const toggleRect = toggle.getBoundingClientRect();
    const gap = 8;
    const below = Math.floor(bodyRect.bottom - toggleRect.bottom - gap);
    const above = Math.floor(toggleRect.top - bodyRect.top - gap);
    const needed = list.scrollHeight;

    const openUp = needed > below && above > below;
    list.classList.toggle('popout-list--top', openUp);
    list.style.setProperty('--max-height', Math.max(openUp ? above : below, 80) + 'px');
    list.style.maxHeight = Math.max(openUp ? above : below, 80) + 'px';
    list.style.overflowY = 'auto';

    // Still not enough room either way: scroll the row into the middle.
    if (needed > Math.max(above, below)) {
      toggle.scrollIntoView({ block: 'center' });
    }
  }

  document.addEventListener('click', function (event) {
    const target = eventElement(event);
    const toggle = target?.closest('[data-popout-toggle]');
    const drawer = getDrawer();
    if (!toggle || !drawer || !drawer.contains(toggle)) return;

    // theme.js sets its own position/max-height inside a rAF; run after it.
    setTimeout(() => fitDrawerPopout(toggle), 60);
  });

  async function parseJsonResponse(res) {
    // Content-type can be mislabeled (e.g. local theme dev proxy), so parse
    // the body instead of trusting headers.
    const text = await res.text();
    try {
      return JSON.parse(text);
    } catch (_e) {
      throw new Error('Unexpected non-JSON response (' + res.status + ')');
    }
  }

  async function refreshDrawer() {
    // When triggered by a quantity change, measure from the customer's click
    // (before cart/change.js) so closing the drawer mid-request counts.
    const refreshedAt = changeInFlight && lastChangeStartedAt ? lastChangeStartedAt : Date.now();
    const sectionId = getDrawerSectionId();

    if (!sectionId) {
      throw new Error('Cart drawer section ID not found');
    }

    const res = await fetch(root + '?sections=' + encodeURIComponent(sectionId), {
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    if (!res.ok) {
      throw new Error('Drawer refresh failed (' + res.status + ')');
    }

    const sections = await parseJsonResponse(res);
    const html = sections[sectionId];

    if (!html) {
      throw new Error('No section HTML returned');
    }

    const newDoc = new DOMParser().parseFromString(html, 'text/html');

    updateInnerHTML(newDoc, 'cart-items[data-items-holder]');
    updateInnerHTML(newDoc, '[data-cart-price-holder]');

    /**
     * Important:
     * This refreshes the checkout button state, so it does not stay as
     * "Cart needs to be updated".
     */
    updateInnerHTML(newDoc, '[data-cart-checkout-buttons]');
    updateInnerHTML(newDoc, '[data-cart-checkout-button]');

    // After the checkout buttons swap (which resets the minimum note to
    // its server-rendered hidden default), apply the fresh campaign state.
    replaceProgressSlot(newDoc);

    updateCartCount(newDoc);
    syncEmptyState(newDoc);

    // Re-open only if the customer hasn't closed the drawer since this
    // refresh started; otherwise the X / overlay click gets undone.
    const reopenIfNotClosed = () => {
      if (lastUserCloseAt >= refreshedAt) return;
      forceDrawerOpen();
    };

    reopenIfNotClosed();
    revealCartItems();

    setTimeout(reopenIfNotClosed, 100);
    setTimeout(revealCartItems, 100);
    setTimeout(reopenIfNotClosed, 400);
    setTimeout(revealCartItems, 400);

    console.log(LOG, 'Drawer refreshed');
  }

  /**
   * Line item keys in the rendered drawer can go stale: apps and discounts
   * may rewrite line item properties after render, which changes the key
   * hash server-side. A change request with the old key then 400s with
   * "no valid id or line parameter". Resolve the current key from /cart.js
   * right before changing; fall back to the row's 1-based line index.
   */
  async function resolveChangeTarget(itemKey, row) {
    try {
      const res = await fetch(root + 'cart.js', {
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      });

      if (res.ok) {
        const cart = await parseJsonResponse(res);
        const items = cart.items || [];

        if (items.some(item => item.key === itemKey)) {
          return { id: itemKey };
        }

        // Stale key: re-match by variant id (key prefix before the colon).
        const variantId = String(itemKey).split(':')[0];
        const matches = items.filter(item => String(item.variant_id) === variantId);

        if (matches.length === 1) {
          console.warn(LOG, 'Stale line item key, re-resolved via variant id');
          return { id: matches[0].key };
        }

        const line = Number(row?.getAttribute('data-item-index') || 0);
        if (line > 0 && line <= items.length) {
          console.warn(LOG, 'Stale line item key, falling back to line index', line);
          return { line: line };
        }
      }
    } catch (error) {
      console.warn(LOG, 'Could not pre-resolve line item, using original key', error);
    }

    return { id: itemKey };
  }

  async function changeCartItem(itemKey, quantity, row) {
    if (!itemKey && itemKey !== 0) return { cartUpdated: false };

    lastChangeStartedAt = Date.now();

    const target = await resolveChangeTarget(itemKey, row);

    console.log(LOG, 'Change item:', target, 'quantity:', quantity);

    const res = await fetch(root + 'cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(Object.assign({ quantity: quantity }, target))
    });

    if (!res.ok) {
      let message = 'Cart change failed';

      try {
        const body = await parseJsonResponse(res);
        message =
          body.description ||
          body.message ||
          (typeof body.errors === 'string' ? body.errors : null) ||
          message;
      } catch (_parseError) {
        // Keep generic message when body is HTML (e.g. rate limit page).
      }

      const error = new Error(message);
      error.status = res.status;
      error.isInventoryLimit = res.status === 422 || isInventoryLimitMessage(message);
      error.cartUpdated = false;
      throw error;
    }

    // The change succeeded; the response body isn't needed, so a parse
    // failure here must not surface as a cart error.
    try {
      await parseJsonResponse(res);
    } catch (_ignoredParseError) {
      console.warn(LOG, 'Could not parse cart/change response body; continuing');
    }

    try {
      await refreshDrawer();
    } catch (refreshError) {
      refreshError.cartUpdated = true;
      throw refreshError;
    }

    return { cartUpdated: true };
  }

  function getItemKeyFromRow(row) {
    const input = row?.querySelector('.cart__quantity-field[data-id]');
    if (input?.dataset?.id) return input.dataset.id;

    const remove = row?.querySelector('[data-item-remove][data-id]');
    if (remove?.dataset?.id) return remove.dataset.id;

    return row?.dataset?.item || null;
  }

  function getCurrentQuantity(row) {
    const input = row?.querySelector('.cart__quantity-field');
    return Math.max(0, Number(input?.value || 0));
  }

  function getItemTitle(row) {
    return (
      row?.dataset?.itemTitle ||
      row?.querySelector('.cart__item__title')?.textContent?.trim() ||
      ''
    );
  }

  async function handleCartClick(event) {
    const drawer = getDrawer();
    const target = eventElement(event);
    if (!drawer || !target || !drawer.contains(target)) return;

    const removeButton = target.closest('[data-item-remove]');
    const plusButton = target.closest('.cart__quantity-plus');
    const minusButton = target.closest('.cart__quantity-minus');
    const popoutOption = target.closest('[data-popout-option]');

    if (!removeButton && !plusButton && !minusButton && !popoutOption) return;

    // Don't swallow REMOVE while another qty update is in flight.
    if (changeInFlight && !removeButton) return;

    const row = target.closest('[data-item]');
    const itemKey = getItemKeyFromRow(row);

    if (!itemKey) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const previousQuantity = getCurrentQuantity(row);
    let nextQuantity = previousQuantity;

    if (removeButton) {
      nextQuantity = 0;
    } else if (plusButton) {
      nextQuantity += 1;
    } else if (minusButton) {
      nextQuantity = Math.max(0, nextQuantity - 1);
    } else if (popoutOption) {
      nextQuantity = Number(popoutOption.dataset.value || nextQuantity);
    }

    // Never treat remove (qty 0) as an inventory-limit violation.
    const maxQuantity = getMaxQuantity(row);
    if (nextQuantity > 0 && maxQuantity != null && nextQuantity > maxQuantity) {
      showInventoryLimitError(getItemTitle(row) || 'This item');
      resetRowQuantity(row, previousQuantity);
      return;
    }

    hideCartError();
    const seq = ++changeSeq;
    changeInFlight = true;
    setRowLoading(row);

    try {
      await changeCartItem(itemKey, nextQuantity, row);
    } catch (error) {
      console.error(LOG, error);

      if (!error.cartUpdated) {
        resetRowQuantity(row, previousQuantity);
        // Re-render rows so stale line item keys are replaced with fresh
        // ones and the next attempt succeeds.
        try {
          await refreshDrawer();
        } catch (refreshError) {
          console.error(LOG, 'Drawer refresh after failure failed', refreshError);
        }
      } else {
        // Cart already changed (e.g. remove succeeded); retry UI sync once.
        try {
          await refreshDrawer();
        } catch (retryError) {
          console.error(LOG, 'Refresh retry failed', retryError);
        }
      }

      if (error.isInventoryLimit) {
        showInventoryLimitError(getItemTitle(row) || 'This item');
      } else if (!error.cartUpdated) {
        showGenericCartError(error.message || 'Please try again.');
      }
    } finally {
      clearRowLoading(row);
      if (seq === changeSeq) {
        changeInFlight = false;
      }
    }
  }

  async function handleQuantityInputChange(event) {
    const target = eventElement(event);
    const input = target?.closest('.cart__quantity-field[data-id]');
    if (!input) return;

    const drawer = getDrawer();
    if (!drawer || !drawer.contains(input)) return;

    if (changeInFlight) return;

    event.preventDefault();
    event.stopPropagation();

    const row = input.closest('[data-item]');
    const itemKey = input.dataset.id;
    const previousQuantity = Number(input.defaultValue || input.value || 0);
    let quantity = Math.max(0, Number(input.value || 0));
    const maxQuantity = getMaxQuantity(row);

    if (quantity > 0 && maxQuantity != null && quantity > maxQuantity) {
      showInventoryLimitError(getItemTitle(row) || 'This item');
      resetRowQuantity(row, previousQuantity);
      return;
    }

    hideCartError();
    const seq = ++changeSeq;
    changeInFlight = true;
    setRowLoading(row);

    try {
      await changeCartItem(itemKey, quantity, row);
      input.defaultValue = String(quantity);
    } catch (error) {
      console.error(LOG, error);

      if (!error.cartUpdated) {
        resetRowQuantity(row, previousQuantity);
        try {
          await refreshDrawer();
        } catch (refreshError) {
          console.error(LOG, 'Drawer refresh after failure failed', refreshError);
        }
      } else {
        try {
          await refreshDrawer();
        } catch (retryError) {
          console.error(LOG, 'Refresh retry failed', retryError);
        }
      }

      if (error.isInventoryLimit) {
        showInventoryLimitError(getItemTitle(row) || 'This item');
      } else if (!error.cartUpdated) {
        showGenericCartError(error.message || 'Please try again.');
      }
    } finally {
      clearRowLoading(row);
      if (seq === changeSeq) {
        changeInFlight = false;
      }
    }
  }

  document.addEventListener('click', function (event) {
    const target = eventElement(event);
    if (target?.closest('[data-cart-drawer-close], [data-drawer-underlay]')) {
      lastUserCloseAt = Date.now();
    }
  }, true);
  document.addEventListener('keyup', function (event) {
    if (event.key === 'Escape') lastUserCloseAt = Date.now();
  }, true);

  document.addEventListener('click', handleCartClick, true);
  document.addEventListener('change', handleQuantityInputChange, true);

  document.addEventListener('click', function (event) {
    const target = eventElement(event);
    if (!target?.closest('[data-cart-error-close]')) return;
    hideCartError();
  });

  /**
   * Expose this so the Rebuy Add callback can use the same refresh method.
   */
  window.KSRefreshBroadcastCartDrawer = async function () {
    await delay(500);
    await refreshDrawer();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchDrawerOpenState);
  } else {
    watchDrawerOpenState();
  }

  console.log(LOG, 'Initialized');
})();
